import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators, FormGroup } from '@angular/forms';

import Swal from 'sweetalert2';

import * as alerts from '../../_functions/alerts';
import { Sac, Addrress, Attachments } from '../../_models/sac';
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { FileAux } from '../../_models/fileAux';
import { ValidacaoService } from '../../_services/validacao.service';
import { ListaAtendimentos } from './lista-atendimentos.model';
import { GrupoFaq } from './grupo-faq.model';

const KEY_PROMOCAO = 'SAC - PROMOÇÃO'

@Component({
  selector: 'app-ajuda',
  templateUrl: './ajuda.component.html',
  styleUrls: ['./ajuda.component.scss'],
})
export class AjudaComponent implements OnInit, AfterViewInit {
  public faq: any[] = [];
  public tituloFaq: string = '';
  public filtroFaq: string = '';
  public chamadoForm: UntypedFormGroup;
  public tiposChamado: ListaAtendimentos[] = [];
  public carregandoFAQ: boolean = false;

  public exibePopupGenerico: boolean = false;
  public tituloPopupGenerico: string = '';
  public descricaoModalGenerico: string[] = [];
  public exibirLoader: boolean = false;

  public enviandoChamado: boolean = false;

  private usuarioLogado: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private fidelidadeService: FidelidadeService,
    private validacaoService: ValidacaoService
  ) {
    window.location.href = 'https://sac.cacaushow.com.br/';
    return
    const paramsSearch = new URLSearchParams(window.location.search);
    let regulamento: string = paramsSearch.get('regulamento');

    if (regulamento != null) {
      regulamento = regulamento === 'lovers' ? 'regulamento' : regulamento;
      this.mostrarPopupRegulamento(regulamento);
    }

    this.route.params.subscribe((params: any) => {
      const tipo: string = params['tipo'].toLowerCase();

      if (tipo === undefined) {
        console.warn('O parâmetro da FAQ não foi reconhecido');
        return;
      }

      this.carregarFaq(tipo);
    });

    this.chamadoForm = this.formBuilder.group({});
    this.carregarFormChamado();

    const tipoAtendimento = this.route.snapshot.queryParams['tipoAtendimento'];

    if (tipoAtendimento && tipoAtendimento === 'promocao') {
      this.chamadoForm.patchValue({
        tipo: KEY_PROMOCAO,
      });
    }
  }

  ngOnInit(): void {
    this.obterListaDeAtendimentos();
  }

  ngAfterViewInit(): void {
    this.route.params.subscribe((params: any) => {
      const url = params['tipo'];
      const id = url.split('#');
      const element = document.getElementById(id[1]);
      if (!element) {
        element?.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });
      }
    });

    this.usuarioLogado = this.authService.LocalStorage.usuarioValido();
    if (this.usuarioLogado) this.obterMembro();
  }

  private obterListaDeAtendimentos() {
    this.fidelidadeService.obterConfiguracaoPorDescricao('ListaDeAtendimentos').subscribe({
      next: (res: any) => {
        this.tiposChamado = (eval(res.valor)).filter((x: any) => x.ativo);
      },
      error: (err: any) => console.log('Erro ao obter lista de atendimentos...', err)
    })
  }

  public exigirInformacoesEcom(value: any): boolean {
    var opcao = this.tiposChamado.find(x => x.chave == value);

    if (!opcao)
      return;

    return opcao.exigeInformacoesEcom;
  }

  private obterMembro(): void {
    this.fidelidadeService.obterMembro().subscribe({
      next: (res: any) => this.preencherForm(res),
      error: (err: any) => console.log(err),
    });
  }

  private preencherForm(membro: any) {
    (this.chamadoForm.get('nome') as FormGroup).setValue(membro.nome);
    (this.chamadoForm.get('cpf') as FormGroup).setValue(membro.cpf);
    (this.chamadoForm.get('email') as FormGroup).setValue(membro.email);

    if (membro.telefone != null) {
      let tel = membro.telefone;
      let telefoneTratado = tel.replace("55", "", 1);
      (this.chamadoForm.get('telefone') as FormGroup).setValue(telefoneTratado);
    }
  }

  private mostrarPopupRegulamento(regulamento: string) {
    this.limparDescricao();
    this.exibirLoader = true;

    this.fidelidadeService.obterConfiguracaoPorDescricao(regulamento).subscribe(
      (sucesso) => {
        this.processarSucessoRegulamento(sucesso);
      },
      (falha) => {
        this.processarFalhaRegulamento(falha);
      }
    );
  }

  private processarSucessoRegulamento(response: any) {
    var linhas = response.valor.split('\n');

    for (let index = 1; index < linhas.length; index++) {
      if (linhas[index] == '\r') continue;

      this.descricaoModalGenerico.push(`${linhas[index]}<br><br>`);
    }

    this.exibirLoader = false;
    this.exibePopupGenerico = true;
    this.tituloPopupGenerico = linhas[0];
  }

  private processarFalhaRegulamento(fail: any) {
    console.error('Ocorreu um erro ao tentar obter o regulamento', fail);
    this.exibirLoader = false;
  }

  private limparDescricao() {
    this.descricaoModalGenerico = [];
  }

  private carregarFormChamado(): void {
    this.chamadoForm = this.formBuilder.group({
      nome: ['', [Validators.required]],
      cpf: ['', [Validators.required]],
      telefone: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      tipo: ['', [Validators.required]],
      numeroPedido: ['', []],
      dataPedido: ['', []],
      descricao: ['', [Validators.required]],
      path: [[], []],
      anexos: [[], []],
      aceitePolitica: [false, []],
      aceiteDados: [false, []],
    });
  }

  private carregarFaq(tipo: string): void {
    this.carregandoFAQ = true;

    if (tipo.includes('#')) {
      tipo = tipo.split('#')[0];
    }

    this.fidelidadeService.obterFAQPorRota(tipo).subscribe({
      next: (response: any) => this.processarSucessoCarregarFAQ(response.resultado),
      error: (err: any) => this.processarFalhaCarregarFAQ(err),
    })
  }

  private processarSucessoCarregarFAQ(grupoFaq: GrupoFaq): void {
    this.faq = grupoFaq.faq;
    this.tituloFaq = grupoFaq.nome;
    this.carregandoFAQ = false;
  }

  private processarFalhaCarregarFAQ(err: any): void {
    console.error('Ocorreu um erro ao carregar a faq', err);
    this.carregandoFAQ = false;
  }

  public carregarAnexos(): void {
    document.getElementById('chamado-anexos')?.click();
  }

  public onAnexo(e: any): void {
    const anexosForm = e.target.files;
    const anexos = this.chamadoForm.value.anexos;

    for (let i = 0; i < anexosForm.length; i++) {
      const arquivo = anexosForm[i];

      if (anexos.length >= 1) {
        alerts.exibirToast(
          'info',
          `Limite de 1 um arquivo atingido! a imagem ${arquivo.name} não foi inclusa na abertura da solicitação.`
        );
        console.warn('Limite de arquivos atingido!');
        continue;
      }

      if (this.validarArquivo(arquivo)) {
        this.readBase64(anexosForm[i]).then((data) => {
          var fileAux: FileAux = new FileAux();

          fileAux.nome = arquivo.name;
          fileAux.tipoArquivo = arquivo.type;
          fileAux.base64 = data;
          fileAux.src = arquivo.type === "application/pdf" ? "assets/images/icons/pdf.png" : data;

          anexos.push(fileAux);
          this.chamadoForm.patchValue({ anexos: anexos });
        });
      }
    }
  }

  public removerAnexo(index: number): void {
    const anexos: FileAux[] = this.chamadoForm.value.anexos;
    anexos.splice(index, 1);
    this.chamadoForm.patchValue({ anexos: anexos });
  }

  public enviarChamado(): void {
    this.enviandoChamado = true;
    const chamado = this.chamadoForm.value;

    if (chamado.tipo === '') {
      alerts.exibirToast('warning', 'Selecione o assunto do atendimento.');
      this.enviandoChamado = false;
      return;
    }

    if (this.exigirInformacoesEcom(chamado.tipo)) {
      if (chamado.numeroPedido === '') {
        alerts.exibirToast('warning', 'Informe o número do pedido.');
        this.enviandoChamado = false;

        return;
      }

      if (chamado.dataPedido === '') {
        alerts.exibirToast('warning', 'Informe a data do pedido.');
        this.enviandoChamado = false;

        return;
      }
    }

    if (!chamado.aceiteDados || !chamado.aceitePolitica) {
      alerts.exibirToast('warning', 'É preciso aceitar os termos para enviar.');
      this.enviandoChamado = false;

      return;
    }

    let nomeArr: string[] = chamado.nome.trim().split(' ');

    if (nomeArr.length <= 1) {
      alerts.exibirToast('warning', 'Informe seu nome completo!');
      this.enviandoChamado = false;

      return;
    }

    if (!this.validacaoService.validarCPF(chamado.cpf)) {
      alerts.exibirToast('warning', 'Informe um CPF válido!');
      this.enviandoChamado = false;

      return;
    }
    const nome = nomeArr[0];
    let sobrenome = '';

    for (let i = 1; i < nomeArr.length; i++) {
      sobrenome += nomeArr[i] + ' ';
    }

    var sac: Sac = new Sac();

    sac.name = nome;
    sac.lastName = sobrenome.trim();
    sac.extenalOrderReference = chamado.numeroPedido;
    sac.extenalOrderDate = chamado.dataPedido;
    sac.addrress = new Addrress();
    sac.addrress.phone = chamado.telefone;
    sac.addrress.email = chamado.email;
    sac.text = chamado.descricao;
    sac.cpf = chamado.cpf;
    sac.typeProcess = chamado.tipo;
    sac.mainCategory = this.tiposChamado.find(c => c.chave == chamado.tipo)?.valor;

    sac.attachments = [];

    chamado.anexos.forEach((anexo: any) => {
      var attachment = new Attachments();

      attachment.content = anexo.base64;
      attachment.type = anexo.tipoArquivo;
      attachment.name = anexo.nome;

      sac.attachments.push(attachment);
    });

    this.authService.getIPAddress().subscribe(
      (res: any) => {
        sac.ip = res.ip;
        this.fidelidadeService.abrirChamadoCRM(sac).subscribe(
          (res: any) => {
            this.processarSucessoAbrirChamado(res);
          },
          (err: any) => {
            this.processarFalhaAbrirChamado(err);
          }
        );
      },
      (err: any) => {
        this.processarFalhaAbrirChamado(err);
      }
    );
  }

  processarSucessoAbrirChamado(res: any): void {
    Swal.fire({
      icon: 'success',
      title: 'Formulário enviado com sucesso!',
      text:
        'Anote o seu número de protocolo para consultas futuras junto ao SAC: ' +
        res.resultado,
    });
    this.enviandoChamado = false;

    this.carregarFormChamado();
  }

  processarFalhaAbrirChamado(err: any): void {
    console.error('Um erro ocorreu ao tentar abrir o chamado', err);

    if (err.startsWith('Já temos uma solicitação'))
      alerts.exibirToastComLargura('danger', err, 'top', 500);
    else
      alerts.exibirToast(
        'danger',
        'Falha ao enviar o e-mail, tente mais tarde.'
      );

    this.enviandoChamado = false;
  }

  validarArquivo(arquivo: File): boolean {
    if (
      arquivo.type != 'image/png' &&
      arquivo.type != 'image/jpeg' &&
      arquivo.type != 'application/pdf'
    ) {
      Swal.fire({
        title: 'Atenção!',
        text: 'Apenas arquivos de imagens no formato jpeg ou png ou arquivos PDF são aceitos',
        icon: 'warning',
        confirmButtonColor: '#2d1708',
        confirmButtonText: 'Ok',
      }).then();
      {
        return;
      }
    }

    return true;
  }

  private readBase64(file): Promise<any> {
    if (file.size / 1024 / 1024 > 3) {
      Swal.fire({
        title: 'Atenção!',
        text: 'O arquivo deve ter o tamanho máximo de 3 megas!',
        icon: 'warning',
        confirmButtonColor: '#2d1708',
        confirmButtonText: 'Ok',
      }).then();
      {
        return;
      }
    } else {
      const reader = new FileReader();
      const future = new Promise((resolve, reject) => {
        reader.addEventListener(
          'load',
          function () {
            resolve(reader.result);
          },
          false
        );
        reader.addEventListener(
          'error',
          function (event) {
            reject(event);
          },
          false
        );

        reader.readAsDataURL(file);
      });
      return future;
    }
  }
}
